import { DestroyRef, Inject, Injectable, OnDestroy, Service, inject } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, RedirectRequest } from '@azure/msal-browser';
import { BehaviorSubject, Observable, Subject } from 'rxjs';


import { B2CPolicies, MSALConfig } from '../models/auth-config.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface IdTokenClaims extends AuthenticationResult {
  idTokenClaims: {
    tfp?: string;
  };
}

@Service()
export class AuthService {
  private _msalGuardConfig = inject(MSAL_GUARD_CONFIG);
  private _broadcastService = inject(MsalBroadcastService);
  private _authService = inject(MsalService);


  private destroyRef = inject(DestroyRef);

  private token: BehaviorSubject<any> = new BehaviorSubject(null);
  setToken(_token: string) {
    this.token.next(_token);
  }
  get tokenValue() {
    return this.token?.value ?? '';
  }

  private _isLogged: BehaviorSubject<boolean> = new BehaviorSubject(null);
  setIsLogged(isLogged: boolean) {
    this._isLogged.next(isLogged);
  }
  get isLogged(): Observable<boolean> {
    return this._isLogged.asObservable();
  }

  constructor() {
    this._broadcastService.msalSubject$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: EventMessage) => {
        if (result.eventType === EventType.LOGIN_SUCCESS || result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
          const payload: IdTokenClaims = result.payload as AuthenticationResult;
          if (payload.idTokenClaims?.tfp?.toLowerCase() === B2CPolicies().names.forgotPassword?.toLowerCase()) {
            window.alert('Password has been reset successfully. \nPlease sign-in with your new password.');
            return this.logout();
          }
          if (!this.token) this.setToken(payload.accessToken);
        }
        // msal-browser 5: LOGIN_FAILURE non esiste più, i fallimenti di login arrivano come ACQUIRE_TOKEN_FAILURE
        if (result.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
          if (!!result.error?.message?.includes('AADB2C90118')) {
            const resetPasswordFlowRequest: RedirectRequest = {
              scopes: ['openid'],
              authority: B2CPolicies().authorities.forgotPassword.authority,
              correlationId: undefined
            };
            this.login(resetPasswordFlowRequest);
          } else {
            this.logout();
          }
        }
      });
  }



  login(userFlowRequest?: RedirectRequest) {
    if (this._msalGuardConfig.authRequest) {
      this._authService.loginRedirect({ ...this._msalGuardConfig.authRequest, ...userFlowRequest } as RedirectRequest).subscribe();
    } else {
      this._authService.loginRedirect(userFlowRequest).subscribe();
    }
  }

  logout(redirectUrl?: string) {
    this._authService.logoutRedirect({
      postLogoutRedirectUri: redirectUrl || MSALConfig().auth.redirectUri
    });
  }
}
